import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Header from 'components/header/Header';
import Footer from 'components/footer/Footer';
import BuyButton from 'components/BuyButton';
import { asyncFetchUltimate } from 'actions/bundles';
import './Ultimate.scss';

import mtUtImg1Webp from 'images/ultimate/webp/mt-ut-img-1.webp';
import mtUtImg1Png from 'images/ultimate/mt-ut-img-1.png';
import mtUtImg2Webp from 'images/ultimate/webp/mt-ut-img-2.webp';
import mtUtImg2Png from 'images/ultimate/mt-ut-img-2.png';
import mtUtImg31 from 'images/ultimate/mt-ut-img-3-1.jpg';
import mtUtImg32 from 'images/ultimate/mt-ut-img-3-2.jpg';
import mtUtImg33 from 'images/ultimate/mt-ut-img-3-3.jpg';
import mtUtImg4Webp from 'images/ultimate/webp/mt-ut-img-4.webp';
import mtUtImg4Png from 'images/ultimate/mt-ut-img-4.png';
import mtUtImg5Webp from 'images/ultimate/webp/mt-ut-img-5.webp';
import mtUtImg5Png from 'images/ultimate/mt-ut-img-5.png';
import mtUtImg6Webp from 'images/ultimate/webp/mt-ut-img-6.webp';
import mtUtImg6Png from 'images/ultimate/mt-ut-img-6.png';
import mtUtImg7Webp from 'images/ultimate/webp/mt-ut-img-7.webp';
import mtUtImg7Png from 'images/ultimate/mt-ut-img-7.png';
import mtUtImg8Webp from 'images/ultimate/webp/mt-ut-img-8.webp';
import mtUtImg8Png from 'images/ultimate/mt-ut-img-8.png';
import mtUtImg9Webp from 'images/ultimate/webp/mt-ut-img-9.webp';
import mtUtImg9Png from 'images/ultimate/mt-ut-img-9.png';
import mtUtImg10Webp from 'images/ultimate/webp/mt-ut-img-10.webp';
import mtUtImg10Png from 'images/ultimate/mt-ut-img-10.png';
import mtUtImg11Webp from 'images/ultimate/webp/mt-ut-img-11.webp';
import mtUtImg11Png from 'images/ultimate/mt-ut-img-11.png';
import mtUtImg12Webp from 'images/ultimate/webp/mt-ut-img-12.webp';
import mtUtImg12Png from 'images/ultimate/mt-ut-img-12.png';
import mtUtImg13Webp from 'images/ultimate/webp/mt-ut-img-13.webp';
import mtUtImg13Png from 'images/ultimate/mt-ut-img-13.png';
import mtUtImg14Webp from 'images/ultimate/webp/mt-ut-img-14.webp';
import mtUtImg14Png from 'images/ultimate/mt-ut-img-14.png';
import mtUtImg15Webp from 'images/ultimate/webp/mt-ut-img-15.webp';
import mtUtImg15Png from 'images/ultimate/mt-ut-img-15.png';

// import signatureImg from 'images/ultimate/signature-affiliates.jpg';
// import avatarImg from 'images/ultimate/avatar-affiliates.png';

const fbq = window.fbq;

export class Ultimate extends Component {
  componentDidMount() {
    document.title = 'Doodly: Doodle images for your animated videos';

    const { location } = this.props;
    if (location.search === '?f') {
      fbq('track', 'PageView');
    }

    this.props.fetchUltimate();
  }

  render() {
    const { clickFunnelsProductId, isUltimateLoading } = this.props;

    return (
      <div className="ultimate d-flex flex-column">
        <Header />
        <section className="marketplace-ut-top">
          <div className="wrap text-center">
            <h1 className="fs-32px-bkbd text-uppercase spacer-20 spacer-xl-30">
              <strong>
                <span className="d-inline-block b-red-tint-1 p-x-10">Special:</span> Own The <u>ENTIRE</u> Doodly
                Marketplace!
              </strong>
            </h1>
            <h2 className="fs-30px-bkbd mb-0">
              <strong>Have The Ultimate Creative Control To Make Professional Doodle Videos</strong>
            </h2>
            <h3 className="fs-46px-bkbd spacer-20 spacer-xl-30">
              <span className="d-xxl-block">
                <strong>By Adding 6,200+ Characters, Props, And Scenes</strong>
              </span>
              <strong> to Your Doodly Library For One Low Price.</strong>
            </h3>

            <div className="hero-video spacer-10">
              <div className="video-area mx-auto">
                <div className="vid-contain">
                  <div className="video">
                    <div className="voomly-embed" data-id="7Zqy0Z24C" data-ratio="1.778" data-type="v"></div>
                  </div>
                </div>
              </div>
            </div>

            <p className="fs-22px-bkbd z-index-10 relative">
              *You’ll get DOUBLE the images, at 12,250+ if you own the Doodly Rainbow add-on!
            </p>
          </div>
        </section>

        <div className="below-top text-center">
          <div className="wrapper-below-top">
            <picture>
              <source type="image/webp" srcSet={mtUtImg1Webp} />
              <source type="image/png" srcSet={mtUtImg1Png} />
              <img src={mtUtImg1Png} alt="" className="img-fluid mt-ut-img-1 spacer-20" />
            </picture>

            <div className="ol-container">
              <BuyButton
                productId={clickFunnelsProductId}
                className="button button-green mb-2"
                productType="ultimate"
                disabled={isUltimateLoading}
              >
                order doodly marketplace ultimate
              </BuyButton>
              <p className="available">INSTANTLY ADDED TO YOUR DOODLY</p>
            </div>
          </div>
        </div>

        <div className="section-all-access">
          <div className="wrapper-inner">
            <p className="fs-19px-bkbd spacer-60">
              Hey everyone! I want to share something with you that will give you the ULTIMATE power to create the very
              best doodle videos, no matter the market or business you’re creating them for.
            </p>

            <div className="mw-662">
              <div className="left-no-images d-none d-xl-block">
                <p className="fs-59px-bkbd mb-0">6,200+</p>
                <p className="fs-30px-bkbd mb-0">IMAGES</p>
              </div>

              <picture>
                <source type="image/webp" srcSet={mtUtImg2Webp} />
                <source type="image/png" srcSet={mtUtImg2Png} />
                <img src={mtUtImg2Png} alt="" className="img-fluid spacer-20 spacer-xl-45" />
              </picture>

              <div className="right-no-images d-none d-xl-block">
                <p className="fs-59px-bkbd mb-0">12,250+</p>
                <p className="fs-30px-bkbd mb-0">IMAGES*</p>
                <p className="fs-19px-bkbd-2">
                  * if you have the Doodly <br />
                  Rainbow add-on.
                </p>
              </div>

              <p className="fs-19px-bkbd text-center spacer-45">
                It’s what we call Doodly Marketplace Ultimate, and it contains <u>every single bundle</u> we sell on
                Doodly Marketplace--that’s a whopping 6,200+ images, or 12,250+, if you have the Doodly Rainbow add-on.
              </p>
            </div>

            <p className="fs-19px-bkbd spacer-45">
              And not only that, but all of them come complete with draw paths for that realistic drawing effect you’re
              looking for. AND… you don’t have to download and import anything. They’ll be automatically added to YOUR
              Doodly software… instantly!
            </p>

            <p className="fs-19px-bkbd mb-0">
              Imagine having literally thousands of props, scenes, and characters to choose from … so you can make
              videos that are more creative, more professional, and way <u>more engaging</u>. Bottom line?
            </p>
          </div>
        </div>

        <div className="section-enjoy-more">
          <div className="wrapper-inner">
            <h2 className="fs-46px-bkbd text-center">
              <strong>People will enjoy your videos more</strong>
            </h2>
            <h3 className="fs-32px-bkbd text-center spacer-35">
              <strong>
                Meaning you’ll enjoy better results… in the form of more clicks, likes, shares, and of course,{' '}
                <u>sales.</u>
              </strong>
            </h3>

            <p className="fs-19px-bkbd spacer-45">
              Plus, Doodly Marketplace Ultimate gives you complete creative control to bring virtually any video script
              to life.
            </p>

            <div className="row text-center">
              <div className="col-xl-4">
                <img src={mtUtImg31} alt="" className="spacer-10" />

                <p className="fs-19px-bkbd spacer-45 px-4">
                  Want to depict a family enjoying dinner together? It’s in there.
                </p>
              </div>

              <div className="col-xl-4">
                <img src={mtUtImg32} alt="" className="spacer-10" />

                <p className="fs-19px-bkbd spacer-45 px-3">
                  Need to show an employee having a meltdown at the office? That’s there too.
                </p>
              </div>

              <div className="col-xl-4">
                <img src={mtUtImg33} alt="" className="spacer-10" />

                <p className="fs-19px-bkbd spacer-45 px-2">
                  Looking for an image of a fitness enthusiast hitting it hard at the gym? Yep, you guessed it
                </p>
              </div>
            </div>

            <p className="fs-19px-bkbd text-center spacer-45">
              <strong>--you’ll find that and much, much more in Doodly Marketplace Ultimate.</strong>
            </p>

            <p className="fs-19px-bkbd spacer-45">
              With a humongous library of characters, props, and scenes to choose from, you’ll always have the perfect
              image to portray any scenario you can dream up.
            </p>

            <p className="fs-19px-bkbd spacer-45">
              Plus, like I said above, the images in Doodly Marketplace Ultimate already have draw paths, so there’s no
              need to manually (and painstakingly!) create draw paths yourself.
            </p>

            <picture>
              <source type="image/webp" srcSet={mtUtImg4Webp} />
              <source type="image/png" srcSet={mtUtImg4Png} />
              <img src={mtUtImg4Png} alt="" className="img-fluid spacer-45 d-block mx-auto" />
            </picture>

            <p className="fs-19px-bkbd spacer-45">
              Instead, just drag the images onto your canvas and voila … <u>instant realistic</u>, professionally drawn
              doodles. And if you happen to create videos for clients, you’ll find that Doodly Marketplace Ultimate
              makes your life soooo much easier.
            </p>

            <p className="fs-19px-bkbd spacer-45">
              No more hunting around to find just the right assets to create client videos--or spending way more money
              than you need to by buying bundles individually. With so many characters, professions, and industries to
              choose from, Doodly Marketplace Ultimate makes it easy to create videos that’ll WOW your clients--no
              matter what product or service they provide.
            </p>

            <p className="fs-19px-bkbd mb-0">
              And, even better, Doodly Marketplace Ultimate comes with a sweet, sweet price tag. More on that in a
              minute, but first ...
            </p>
          </div>
        </div>

        <div className="section-what-will-get">
          <div className="wrapper-outer">
            <h2 className="fs-32px-bkbd text-center mb-0">
              <strong>Let me tell you what you’ll get with</strong>
            </h2>
            <h3 className="fs-46px-bkbd text-center spacer-55">
              <strong>Doodly Marketplace Ultimate…</strong>
            </h3>

            <div className="row col-xl-36-64">
              <div className="col-xl-4">
                <p className="fs-19px-bkbd spacer-45">
                  Doodly Marketplace Ultimate consists of all 126 bundles sold on Doodly Marketplace -- a total of 111
                  standard bundles (Normally $27 a piece) and 15 premium bundles (Normally $37 a piece).
                </p>
                <p className="fs-19px-bkbd spacer-45">
                  So, you’ll get a whopping 6,200+ black-and-white props, characters, and scenes.
                </p>
                <p className="fs-19px-bkbd spacer-45">
                  And, if you have the Doodly Rainbow add-on, you’ll also get all those same images in full
                  color--12,250+ in total.
                </p>
              </div>

              <div className="col-xl-8">
                <div className="d-flex spacer-20 justify-content-center justify-content-xl-start">
                  <div className="m-r-40 ">
                    <p className="fs-79px-bkbd mb-0">126</p>
                    <p className="fs-25px-bkbd text-uppercase">Bundles</p>
                  </div>
                  <div className="pt-1">
                    <p className="badge-standard fs-23px-bkbd mb-0">111 standard</p>
                    <p className="badge-premium fs-23px-bkbd">15 premium</p>
                  </div>
                </div>

                <div className="relative d-flex flex-column align-items-center align-items-xl-start">
                  <p className="fs-120px-bkbd c-gray-tint-1 mb-0">
                    <strong>
                      6200<sup>+</sup>
                    </strong>
                  </p>
                  <p className="fs-42px-bkbd spacer-25">
                    <strong>IMAGES</strong>
                  </p>

                  <p className="text-uppercase fs-17px-bkbd">
                    <span className="d-xl-block">* 12,250+ if you have</span>
                    doodly rainbow
                  </p>

                  <picture>
                    <source type="image/webp" srcSet={mtUtImg5Webp} />
                    <source type="image/png" srcSet={mtUtImg5Png} />
                    <img src={mtUtImg5Png} alt="" className="mt-ut-img-5 spacer-45" />
                  </picture>
                </div>
              </div>
            </div>

            <p className="fs-19px-bkbd spacer-45">
              Doodly Marketplace Ultimate contains images from all the different categories on Doodly Marketplace,
              including:
            </p>

            <div className="row spacer-45">
              <div className="col-sm-6 col-lg-3">
                <div className="p-l-30">
                  <p className="check-green mb-2">Animals</p>
                  <p className="check-green mb-2">Business</p>
                  <p className="check-green mb-2">Careers</p>
                  <p className="check-green mb-2">Character Actions</p>
                </div>
              </div>

              <div className="col-sm-6 col-lg-3">
                <div className="p-l-30">
                  <p className="check-green mb-2">Education</p>
                  <p className="check-green mb-2">Family</p>
                  <p className="check-green mb-2">Food</p>
                  <p className="check-green mb-2">General</p>
                </div>
              </div>

              <div className="col-sm-6 col-lg-3">
                <div className="p-l-30">
                  <p className="check-green mb-2">Health</p>
                  <p className="check-green mb-2">Hobbies</p>
                  <p className="check-green mb-2">Nature</p>
                  <p className="check-green mb-2">Science</p>
                </div>
              </div>

              <div className="col-sm-6 col-lg-3">
                <div className="p-l-30">
                  <p className="check-green mb-2">Sports</p>
                  <p className="check-green mb-2">Technology</p>
                  <p className="check-green mb-2">Travel</p>
                  <p className="check-green mb-2">Wealth</p>
                </div>
              </div>
            </div>

            <p className="fs-19px-bkbd">
              So, let me tell you more about some of the images you’ll get in Doodly Marketplace Ultimate.
            </p>
          </div>
        </div>

        <div className="section-category-1">
          <div className="wrapper-inner">
            <div className="row col-xl-65-35">
              <div className="col-xl-6">
                <h2 className="fs-25px-bkbd text-uppercase mb-0">category #1</h2>
                <h3 className="fs-46px-bkbd spacer-35">
                  <strong>Character Actions</strong>
                </h3>

                <p className="fs-19px-bkbd spacer-45">
                  An investment in Doodly Marketplace Ultimate is a <u className="text-nowrap">no-brainer</u> for its
                  character images alone. With 34 character action bundles (that’s right, 34!), you’ll get 1,650
                  characters (3,050 with Doodly Rainbow) displaying different moods, gestures, and expressions in a{' '}
                  <u>huge</u> variety of settings--so you can create videos that perfectly portray people’s feelings.
                </p>

                <p className="fs-19px-bkbd spacer-xl-0 spacer-45">
                  And because your prospects will relate better to these expressive characters, they’ll enjoy watching
                  your Doodles that much more. That alone makes this pack worth it, but here’s the best part … Doodly
                  Marketplace Ultimate costs much, much less than you’d spend if you bought these character bundles
                  individually. WOO-HOO!
                </p>
              </div>

              <div className="col-xl-6 text-center">
                <picture>
                  <source type="image/webp" srcSet={mtUtImg6Webp} />
                  <source type="image/png" srcSet={mtUtImg6Png} />
                  <img src={mtUtImg6Png} alt="" className="mt-ut-img-6" />
                </picture>
              </div>
            </div>
          </div>
        </div>

        <div className="section-category-2">
          <div className="wrapper-inner">
            <div className="row col-xl-35-65">
              <div className="col-xl-6 text-center order-1 order-xl-0">
                <picture>
                  <source type="image/webp" srcSet={mtUtImg7Webp} />
                  <source type="image/png" srcSet={mtUtImg7Png} />
                  <img src={mtUtImg7Png} alt="" className="mt-ut-img-7" />
                </picture>
              </div>

              <div className="col-xl-6 order-0 order-xl-1">
                <h2 className="fs-25px-bkbd text-uppercase mb-0">category #2</h2>
                <h3 className="fs-46px-bkbd spacer-35">
                  <strong>Business</strong>
                </h3>

                <p className="fs-19px-bkbd spacer-45 pr-xl-4">
                  Need to show someone slaving away at the office? You’ll find all that and more with these
                  super-versatile, business-related images. Doodly Marketplace Ultimate comes with 15 bundles (5 of them
                  premium!) that depict everyday office activities, like marketing, e-commerce, presentations, online
                  shopping, and typical office behaviors.
                </p>

                <p className="fs-19px-bkbd spacer-xl-0 spacer-45 pr-xl-4">
                  Whether you promote a service or sell products online, you’ll find tons of great characters, props,
                  and scenes in Doodly Marketplace Ultimate to illustrate business people, concepts, and settings … so
                  your videos are more realistic, more engaging, and more professional.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="section-category-3">
          <div className="wrapper-inner">
            <div className="row col-xl-65-35">
              <div className="col-xl-6">
                <h2 className="fs-25px-bkbd text-uppercase mb-0">category #3</h2>
                <h3 className="fs-46px-bkbd spacer-35">
                  <strong>Family</strong>
                </h3>

                <p className="fs-19px-bkbd spacer-45">
                  Doodly Marketplace Ultimate makes it easy to show prospects you understand what’s important to
                  them--how they spend their time, who they spend it with, and what the big milestones are in their
                  lives.
                </p>

                <p className="fs-19px-bkbd spacer-xl-0 spacer-45">
                  With 9 Doodly Marketplace bundles, you’ll get plenty of images depicting couples, kids, babies,
                  grandparents, weddings, and pregnancies. You’ll also find images depicting families spending time
                  together in all kinds of heartwarming ways--as well as those moments when they’ve clearly “enjoyed”
                  way too much family togetherness!
                </p>
              </div>

              <div className="col-xl-6 text-center">
                <picture>
                  <source type="image/webp" srcSet={mtUtImg8Webp} />
                  <source type="image/png" srcSet={mtUtImg8Png} />
                  <img src={mtUtImg8Png} alt="" className="mt-ut-img-8" />
                </picture>
              </div>
            </div>
          </div>
        </div>

        <div className="section-category-4">
          <div className="wrapper-inner">
            <div className="row col-xl-35-65">
              <div className="col-xl-6 text-center order-1 order-xl-0">
                <picture>
                  <source type="image/webp" srcSet={mtUtImg9Webp} />
                  <source type="image/png" srcSet={mtUtImg9Png} />
                  <img src={mtUtImg9Png} alt="" className="mt-ut-img-9" />
                </picture>
              </div>

              <div className="col-xl-6 order-0 order-xl-1">
                <h2 className="fs-25px-bkbd text-uppercase mb-0">category #4</h2>
                <h3 className="fs-46px-bkbd spacer-35">
                  <strong>Health</strong>
                </h3>

                <p className="fs-19px-bkbd spacer-45 pr-xl-4">
                  Doodly Marketplace Ultimate is chock full of 550 images (1,100 if you have the Doodly Rainbow add-on)
                  depicting health habits--both good and bad. In it, you’ll find people eating healthy, consuming junk
                  food, working out, grooming themselves, and more.
                </p>

                <p className="fs-19px-bkbd spacer-xl-0 spacer-45 pr-xl-4">
                  With 11 Doodly Marketplace bundles (3 of them premium!) featuring weight loss, gym attendance,
                  personal hygiene, fitness, dental care, doctors, medical settings, and salons, you’ll have everything
                  you need to educate, inspire, and sell to prospects who prioritize their health and appearance.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="section-category-5">
          <div className="wrapper-inner">
            <div className="row col-xl-65-35">
              <div className="col-xl-6">
                <h2 className="fs-25px-bkbd text-uppercase mb-0">category #5</h2>
                <h3 className="fs-46px-bkbd spacer-35">
                  <strong>Technology</strong>
                </h3>

                <p className="fs-19px-bkbd spacer-45">
                  With the 10 Doodly Marketplace bundles you’ll get in Doodly Marketplace Ultimate (2 of them premium!),
                  you can easily feature prospects engaging in the type of tech activities they do everyday, like
                  surfing the web, receiving email, playing games online, liking social media posts, etc.
                </p>

                <p className="fs-19px-bkbd spacer-xl-0 spacer-45">
                  And with tons of images showing technology being used at home and at the office, these characters,
                  props, and settings are a MUST for marketers, IT firms, B2B companies, and any Doodly video creator
                  who needs to depict the common tech of our times--which is to say, EVERYONE.
                </p>
              </div>

              <div className="col-xl-6 text-center">
                <picture>
                  <source type="image/webp" srcSet={mtUtImg10Webp} />
                  <source type="image/png" srcSet={mtUtImg10Png} />
                  <img src={mtUtImg10Png} alt="" className="mt-ut-img-10" />
                </picture>
              </div>
            </div>
          </div>
        </div>

        <div className="section-category-6">
          <div className="wrapper-inner">
            <div className="row col-xl-35-65">
              <div className="col-xl-6 text-center order-1 order-xl-0">
                <picture>
                  <source type="image/webp" srcSet={mtUtImg11Webp} />
                  <source type="image/png" srcSet={mtUtImg11Png} />
                  <img src={mtUtImg11Png} alt="" className="mt-ut-img-11" />
                </picture>
              </div>

              <div className="col-xl-6 order-0 order-xl-1">
                <h2 className="fs-25px-bkbd text-uppercase mb-0">category #6</h2>
                <h3 className="fs-46px-bkbd spacer-35">
                  <strong>Animals</strong>
                </h3>

                <p className="fs-19px-bkbd spacer-45 pr-xl-4">
                  People are wild about animals--which is why adding one to your Doodly videos is a great way to grab
                  people’s attention and <u>keep</u> it. Fortunately, with Doodly Marketplace Ultimate, you’ll have
                  plenty (450) of animals to choose from (900 with Doodly Rainbow).
                </p>

                <p className="fs-19px-bkbd spacer-xl-0 spacer-45 pr-xl-4">
                  In the pack, you’ll find vivid graphics featuring wildlife, pets, bugs, and even animals engaged in
                  goofy activities. These images are the perfect way to make your videos more engaging, appeal to
                  children, incorporate humor, or to add realism to a domestic or outdoor setting.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="section-category-7">
          <div className="wrapper-inner">
            <div className="row col-xl-65-35">
              <div className="col-xl-6">
                <h2 className="fs-25px-bkbd text-uppercase mb-0">category #7</h2>
                <h3 className="fs-46px-bkbd spacer-35">
                  <strong>General</strong>
                </h3>

                <p className="fs-19px-bkbd spacer-45">
                  Want tons of cool props to make your videos that much more interesting? You’ll love the 8 general
                  bundles in Doodly Marketplace Ultimate. With hundreds of new objects in your library, you’ll have
                  everything you need to create incredibly realistic videos.
                </p>

                <p className="fs-19px-bkbd spacer-xl-0 spacer-45">
                  Plus, these images are great for illustrating just about any concept you can dream up. Use the
                  magnifying glass to examine an idea further, the question mark to indicate confusion, the piles of
                  cash to pique prospects’ curiosity, etc … with oodles of objects to choose from, if you can dream it,
                  the hand can draw it :)
                </p>
              </div>

              <div className="col-xl-6 text-center">
                <picture>
                  <source type="image/webp" srcSet={mtUtImg12Webp} />
                  <source type="image/png" srcSet={mtUtImg12Png} />
                  <img src={mtUtImg12Png} alt="" className="mt-ut-img-12" />
                </picture>
              </div>
            </div>
          </div>
        </div>

        <div className="section-category-8">
          <div className="wrapper-inner">
            <div className="row col-xl-35-65">
              <div className="col-xl-6 text-center order-1 order-xl-0">
                <picture>
                  <source type="image/webp" srcSet={mtUtImg13Webp} />
                  <source type="image/png" srcSet={mtUtImg13Png} />
                  <img src={mtUtImg13Png} alt="" className="mt-ut-img-13" />
                </picture>
              </div>

              <div className="col-xl-6 order-0 order-xl-1">
                <h2 className="fs-25px-bkbd text-uppercase mb-0">category #8</h2>
                <h3 className="fs-46px-bkbd spacer-35">
                  <strong>Nature</strong>
                </h3>

                <p className="fs-19px-bkbd spacer-45 pr-xl-4">
                  There may be no better way to set the tone of your video than by using the perfect backdrop--Mother
                  Nature! Fortunately, Doodly Marketplace Ultimate contains 5 amazing nature bundles, giving you plenty
                  of great graphics to choose from.
                </p>

                <p className="fs-19px-bkbd spacer-xl-0 spacer-45 pr-xl-4">
                  With images of everything from treehuggers to bucolic outdoor settings, these nature bundles are great
                  for enhancing your storytelling, appealing to nature-loving prospects, promoting eco-friendly causes,
                  and adding realism to videos that are set outdoors.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="section-how-can-you-get">
          <div className="wrapper-inner">
            <p className="fs-19px-bkbd spacer-45">
              These are just a small fraction of what you’ll get in Doodly Marketplace Ultimate. You’ll actually get
              tons more images depicting virtually any subject imaginable, like education, careers, hobbies, food,
              science, sports, travel, wealth ...
            </p>

            <p className="fs-19px-bkbd spacer-45">You get the idea ;)</p>

            <p className="fs-19px-bkbd spacer-45">
              With <u>lifetime access to a GINORMOUS Doodly library</u>, you’ll have thousands of images that’ll help
              you create even better Doodly videos, so you enjoy longer view times, better brand recall, more leads, and
              higher sales … <u>now and for years to come.</u>
            </p>

            <h2 className="fs-46px-bkbd text-center spacer-50">
              <span className="d-xl-block">
                <strong>How You Can Get</strong>
              </span>
              <strong>Doodly Marketplace Ultimate</strong>
            </h2>

            <p className="fs-19px-bkbd spacer-45">
              By now, you’re probably wondering how you can get Doodly Marketplace Ultimate. Before I reveal the price,
              let me just tell you that it was actually really expensive to make the thousands of images available in
              the Doodly Marketplace.
            </p>

            <p className="fs-19px-bkbd spacer-45">
              Imagine having an entire team of graphic designers spend <u>multiple years</u> drawing all these images
              and their draw paths. It was a labor-intensive, 6-figure project.
            </p>

            <div className="row">
              <div className="col-xl-6">
                <p className="fs-19px-bkbd spacer-45">
                  Fortunately, although we had to spend crazy amounts of money for these images, we’re not going to make
                  you do the same thing … with this special offer, we’re literally charging just <u>pennies</u> per
                  doodle image.
                </p>

                <p className="fs-19px-bkbd spacer-45">
                  In fact, if you were to go to the Doodly Marketplace right now to buy these characters, props, and
                  scenes, it’d cost you thousands of dollars--$3,678 to be exact.
                </p>

                <p className="fs-19px-bkbd spacer-45">
                  Instead, we’re making Doodly Marketplace Ultimate available for a SUPER discounted price of just $497,
                  which is <strong>more than 85% off the regular retail price.</strong>
                </p>
              </div>

              <div className="col-xl-6">
                <picture>
                  <source type="image/webp" srcSet={mtUtImg14Webp} />
                  <source type="image/png" srcSet={mtUtImg14Png} />
                  <img src={mtUtImg14Png} alt="" className="mt-ut-img-14 spacer-30" />
                </picture>

                <div className="mw-350 d-flex flex-column flex-sm-row justify-content-between">
                  <div className="text-center">
                    <p className="fs-17px-bkbd text-uppercase mb-0">126 bundles</p>
                    <p className="fs-46px-bkbd f-f-gotham-l">
                      <del>$3,678</del>
                    </p>
                  </div>

                  <div className="text-center">
                    <p className="fs-17px-bkbd text-uppercase mb-0">
                      <strong>126 bundles</strong>
                    </p>
                    <p className="fs-46px-bkbd anchor-coupon">
                      <strong>$497</strong>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <p className="fs-19px-bkbd spacer-45">
              Frankly, that’s a steal when you consider (1) how much you’d have to spend to purchase these images
              individually, and (2) what better videos are gonna do for your sales. Heck, with just one video, your
              investment could pay for itself.
            </p>

            <p className="fs-19px-bkbd mb-0">
              And again, with that investment, you’ll get <u>lifetime access</u> to 6,200+ custom-drawn graphics
              (12,250+ with the Rainbow add-on) you can use to make your videos more engaging, more professional, and
              more effective …
            </p>
          </div>
        </div>

        <div className="section-dont-wait">
          <div className="wrapper-inner">
            <h2 className="fs-46px-bkbd text-center spacer-5">
              <strong>Why You Don’t Want to Wait</strong>
            </h2>
            <h3 className="fs-25px-bkbd text-center spacer-50">
              <strong>You can get the Doodly Marketplace Ultimate right now for just $497.</strong>
            </h3>

            <p className="fs-19px-bkbd spacer-45">
              However, because the marketplace bundles are so heavily discounted in Doodly Marketplace Ultimate, we
              can’t keep the price this low forever… as it drastically lowers the value of the marketplace for obvious
              reasons.
            </p>

            <p className="fs-19px-bkbd spacer-45">
              <u>That’s why to lock in this special $497 one-time rate</u>, you’ll want to get Doodly Marketplace
              Ultimate today. We’ll likely never be able to afford selling it at a lower price, and if you wait, you
              risk paying more for it later.
            </p>

            <p className="fs-19px-bkbd spacer-45">
              So, to start making better, more professional Doodly videos right away, just click on the button below
              right now to get Doodly Marketplace Ultimate.
            </p>
          </div>
        </div>

        <div className="section-order-now">
          <div className="wrapper-inner text-center">
            <picture>
              <source type="image/webp" srcSet={mtUtImg15Webp} />
              <source type="image/png" srcSet={mtUtImg15Png} />
              <img src={mtUtImg15Png} alt="" className="img-fluid spacer-30" />
            </picture>
          </div>

          <div className="mw-885">
            <div className="ol-container text-center">
              <BuyButton
                productId={clickFunnelsProductId}
                className="button button-green mb-2"
                productType="ultimate"
                disabled={isUltimateLoading}
              >
                Give Me Doodly Marketplace Ultimate Now!
              </BuyButton>
              <p className="available">INSTANTLY ADDED TO YOUR DOODLY</p>
            </div>
          </div>
        </div>

        <div className="section-pre-footer">
          <div className="wrapper-inner">
            <p className="fs-19px-bkbd spacer-45">
              Once you’ve entered your payment information, your Doodly software will be updated automatically, so you
              can immediately start using thousands of new characters, props, and scenes to create more engaging videos.
            </p>

            <p className="fs-19px-bkbd spacer-45">
              Thanks for your time—I can’t wait to see the professional videos you create once you have Doodly
              Marketplace Ultimate.
            </p>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    clickFunnelsProductId: state.bundles.ultimate?.clickFunnelsProductId,
    isUltimateLoading: state.bundles.isUltimateLoading
  };
};

const mapDispatchToProps = dispatch => ({
  fetchUltimate: () => dispatch(asyncFetchUltimate())
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Ultimate));
